export default __webpack_public_path__ + "static/media/meat.258c0506.webp";